import React, { useMemo } from 'react';
import {
  cohortConfigTypeSelector,
  rowSelector,
} from '../../redux/selectors/builder';
import { SimpleCohortTypeKey } from '../../utils/apollo/graphqlSchema';
import { getCohortPercentileFilterLabel } from '../../utils/builder/cohorts';
import { ICohortRow, IRowMeta } from '../../redux/slices/oldBuilder';
import * as SaveEntityHeaderUI from './SaveEntityHeaderUI';
import { useAppSelector } from '../../redux/hooks';
import DatePickerDisplay from '../Builder/DatePickerWidget/DateRangeDisplay/DatePickerDisplay';
import ThinDivider from '../ThinDivider';

interface IProps {
  rowMeta: IRowMeta;
}

export default ({ rowMeta }: IProps) => {
  const currentRow: ICohortRow = useAppSelector((state) =>
    rowSelector(state, rowMeta),
  );

  const { simpleCohortTypeKey, percentileFilter, datePicker } = currentRow;

  const cohortConfigSelector = useAppSelector((state) =>
    cohortConfigTypeSelector(state, simpleCohortTypeKey),
  );

  const percentileOperators = useMemo(() => {
    if (
      cohortConfigSelector.__typename === 'ExpressionCohortConfig' &&
      simpleCohortTypeKey === SimpleCohortTypeKey.Expression
    ) {
      return cohortConfigSelector.percentileOperators;
    }
    if (
      cohortConfigSelector.__typename === 'MeasureCohortConfig' &&
      simpleCohortTypeKey === SimpleCohortTypeKey.Measure
    ) {
      return cohortConfigSelector.percentileOperators;
    }

    return null;
  }, [cohortConfigSelector, simpleCohortTypeKey]);

  const renderPercentileFilterInfo = () => {
    if (!percentileFilter || !percentileOperators?.length) {
      return null;
    }

    const { operator, values } = percentileFilter;

    const operatorName =
      percentileOperators.find(
        (percentileOperator) => percentileOperator.key === operator,
      )?.name ?? '';

    return (
      <>
        <ThinDivider layout="vertical" size="short" />
        <SaveEntityHeaderUI.Value>
          {getCohortPercentileFilterLabel({
            operatorKey: operator,
            operatorName,
            values,
          })}
        </SaveEntityHeaderUI.Value>
      </>
    );
  };

  return (
    <>
      {renderPercentileFilterInfo()}
      {datePicker && (
        <>
          <ThinDivider layout="vertical" size="short" />
          <SaveEntityHeaderUI.Value>
            <DatePickerDisplay datePicker={datePicker} />
          </SaveEntityHeaderUI.Value>
        </>
      )}
    </>
  );
};
